let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("28xgG")).then(() => parcelRequire('1UYns'));